<div class="style-flex mt-5">
  <div class="m-auto" style="width: 500px">
    <nk-card>
      <nk-card-content *ngIf="signedUpUserAccount">
        <div class="text-center">
          <h2>
            {{ 'sign_up.success.congratulations_signed_up' | translate }}
          </h2>
          <p class="colorize text primary"><i class="fa fa-handshake-o fa-3x"></i></p>
          <h4 [innerHTML]="'sign_up.success.check_your_email_for_verification_link' | translate"></h4>

          <button nkButton (click)="tryAutomaticallyLoginUser()" color="success" size="lg">
            {{ 'sign_up.success.verified_email_btn' | translate }}
          </button>

          <!--Todo try to login here untill user has verified-->

          <!--<button andClass="mt-2" nkButton color="secondary" size="sm">I have verified my email, take me to the application</button>-->
          <p class="text-muted mt-5" [innerHTML]="'sign_up.success.try_checking_your_spam_folder' | translate"></p>
        </div>
      </nk-card-content>
      <nk-card-content
        *ngIf="!signedUpUserAccount"
        [innerHTML]="'sign_up.success.something_went_wrong_help' | translate">
      </nk-card-content>
    </nk-card>
  </div>
</div>
